import { render } from "./SectionMenu.vue?vue&type=template&id=4326638a&scoped=true"
import script from "./SectionMenu.vue?vue&type=script&lang=js"
export * from "./SectionMenu.vue?vue&type=script&lang=js"

import "./SectionMenu.vue?vue&type=style&index=0&id=4326638a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4326638a"]])

export default __exports__